import { NgModule } from 'ng-metadata/core';
import {AlmaViewerService} from '../delivery/almaViewer/almaViewer.service';
import {RepresentationViewerService} from '../delivery/representationViewer/representationViewer.service';

import {SearchResultModule} from './searchResult/searchResult.module';
import {ReferenceEntryModule} from './referenceEntry/referenceEntryItem.module';
import {SearchFieldsService} from './search.fields.service';
import {SearchStateService} from './searchState.service';
import {Cheetah} from './cheetah.service';
import {SearchResultParser} from './searchResultParser.service';
import {FacetModule} from './facet/facet.module';
import {SearchBarModule} from './searchBar/searchBar.module';
import {PreFiltersModule} from './preFilters/preFilters.module';
import {ResourceTypeFilterBarModule} from './resourceTypeFilterBar/resourceTypeFilterBar.module';
// import {FullViewModule} from './fullView/fullView.module';
import {RtaService} from './rta.service';
import {HighlightsService} from './highlight/highlight.service';
import {SearchService} from './search.service';
import {SearchSavedQueriesModule} from './savedQueries/searchSavedQueries.module';
import {CitationTrailsModule} from './citationTrails/citationTrails.module';
import {DidUMeanModule} from './didUMean/didUMean.module';
import {StaticModule} from '../static/static.module';
import {TopbarModule} from './topbar/topbar.module';
import {PrmSearch} from './search.directive';
import {AutoComplete} from './autocomplete.service';
import {VirtualBrowseModule} from './virtualBrowse/virtualBrowse.module';
import {BrowserStorageManagerModule} from '../security/browserStorageManager.module';
import {ResourceRecommenderModule} from './resourceRecommender/resourceRecommender.module';
import {PersonalizeResultsButtonModule} from './personalization/personalizeResultsButton.module';
import {ControlledVocabularyModule } from './controlledVocabulary/controlledVocabulary.module';
import {PrmSearchErrorMessage} from './searchResult/errorMessage/searchErrorMessage.directive';
import {DirectLinkService} from "./directLink/directLink.service";
import {DatabasesCategorizeService} from "../journals/databasesCategorize/databasesCategorize.service";
import {MoreLikeThisModule} from "./moreLikeThis/moreLikeThis.module";
import { OrgListCategorizeService } from '../journals/orgListCategorize/orgListCategorize.service';
import {NgrsModule} from './fullView/ngrs/ngrs.module';

@NgModule({
    declarations: [
        PrmSearch,
        PrmSearchErrorMessage
    ],
    providers: [
        AutoComplete,
        Cheetah,
        HighlightsService,
        RtaService,
        SearchFieldsService,
        SearchResultParser,
        SearchService,
        SearchStateService,
        DirectLinkService,
        DatabasesCategorizeService,
        OrgListCategorizeService,
        AlmaViewerService,
        RepresentationViewerService
    ],
    imports:[
        CitationTrailsModule,
        ControlledVocabularyModule,
        DidUMeanModule,
        FacetModule,
        ResourceRecommenderModule,
        ReferenceEntryModule,
        SearchBarModule,
        PreFiltersModule,
        ResourceTypeFilterBarModule,
    	SearchResultModule,
        SearchSavedQueriesModule,
        StaticModule,
        TopbarModule,
        VirtualBrowseModule,
        BrowserStorageManagerModule,
        PersonalizeResultsButtonModule,
        NgrsModule,
        MoreLikeThisModule
    ]
})
export class SearchModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/search.module.ts